<template>
    <layout title="Cottonseed Bids">
        <div class="px-8">
            <div class="lg:grid lg:grid-cols-12 bg-blue-50">
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ item.available_amount  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity Requested</div>
                </div>
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">${{ item.price | currency  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Bid Price</div>
                </div>
                <div class="px-6 py-4 lg:col-span-6 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ item.expires_at | niceTimestamp  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Expiration</div>
                </div>
            </div>
            <div class="lg:grid lg:grid-cols-12 mt-4 border-dashed border-b-4 border-gray-200 pb-4">
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Transport
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.transport }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Shipment Period
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.shipment_period }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Location
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.location }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-12">
                    <dt class="text-sm font-medium text-gray-500">
                        Comments
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.comments }}
                    </dd>
                </div>
            </div>
            <div class="lg:grid lg:grid-cols-12 mt-4">
                <form @submit.prevent="submit"  class="grid grid-cols-6 gap-6 col-span-12 sm:col-span-4 sm:col-start-5 bg-gray-50 p-8">
                    <div class="col-span-12">
                        <div v-if="!bidByPercent">
                            <label for="bid_quantity" class="block text-sm font-medium text-gray-700">Bid Quantity (tons)</label>
                            <text-input v-model="bid.bid_quantity" type="number" step=".01" :max="item.available_amount" name="bid_quantity" id="bid_quantity" class="mt-1" />
                        </div>
                        <div v-if="bidByPercent">
                            <label for="bid_percent" class="block text-sm font-medium text-gray-700">Bid Percent</label>
                            <text-input v-model="bid.bid_percent" type="number" step="1" name="bid_percent" id="bid_percent" class="mt-1" />
                            <label for="total_bale_estimate" class="block text-sm font-medium text-gray-700 mt-4">Total Bale Estimate</label>
                            <text-input v-model="bid.total_bale_estimate" type="number" step="1" name="total_bale_estimate" id="total_bale_estimate" class="mt-1" />
                        </div>
                        <loading-button :loading="saving"  type="submit" class="mt-4">
                            Accept Bid
                        </loading-button>
                        <a v-if="!bidByPercent" href="#" @click.prevent="bidByPercent = true" class="mt-4 text-sm flex items-center text-blue-600">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                            </svg>
                            <span>Bid by Percentage</span>
                        </a>
                        <a v-if="bidByPercent" href="#" @click.prevent="bidByPercent = false" class="mt-4 text-sm flex items-center text-blue-600">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                            </svg>
                            <span>Bid by Quantity</span>
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from "@/Shared/Layout";
import TextInput from "@/Shared/TextInput";
import LoadingButton from "@/Shared/LoadingButton";

export default {
    components: {TextInput, Layout, LoadingButton},
    name: "CottonseedBidDetails",
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            bidByPercent: false,
            bid: {
                id: this.item.id,
                bid_quantity: 0,
                bid_percent: 0,
                total_bale_estimate: 0,
            }
        }
    },
    methods: {
        submit() {
            this.$inertia.post(this.route('cottonseed-bids.accept'), this.bid, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => this.editItem = false,
            })
        }
    }
}
</script>

<style scoped>

</style>
